import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../../../app/actions/generalActions";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { useSubheader } from "../../../../../_metronic/layout";
import { ModalProgressBar } from "../../../../../_metronic/_partials/controls";
import { useIntl } from 'react-intl';
import { UserEditForm } from "./UserEditForm";
import { FilterObjectsUIProvider } from "../../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext";



export function UserEdit({
  basePath,
  isFullAccess,
  api,
  prepareFilter,
  currentState,
  initObject,
  formFields,
  otherFields,
  ObjectEditSchema,
  otherTabs,
  history,
  match: {
    params: { id },
  },

}) {
  // Subheader
  const suhbeader = useSubheader();

  const intl = useIntl();
  // Tabs
  const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState();
  const dispatch = useDispatch();
  // const layoutDispatch = useContext(LayoutContext.Dispatch);
  const { actionsLoading, objectForEdit } = useSelector(
    (state) => ({
      actionsLoading: currentState.actionsLoading,
      objectForEdit: currentState.objectForEdit,
    }),
    shallowEqual
  );

  const { name } = currentState;

  useEffect(() => {
    dispatch(actions.fetchObject(api, name, id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = id ? "" : intl.formatMessage({ id: "MODULES.GENERAL.ADDNEWRECORD" });
    if (objectForEdit && id) {
      _title = intl.formatMessage({ id: "MODULES.GENERAL.ADDNEWRECORD" });
    }

    setTitle(_title);
    suhbeader.setTitle(_title);

  }, [objectForEdit, id]);

  const saveObject = (values) => {
    if (!id) {
      dispatch(actions.createObject(api, name, values)).then(() => backToObjectsList());
    } else {
      dispatch(actions.updateObject(api, name, values)).then(() => backToObjectsList());
    }
  };

  const btnRef = useRef();
  const saveObjectClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  const backToObjectsList = () => {
    history.push(basePath);
  };

  const getTab = (item) => {
    if ((tab === item.tab) && id) {
      return <item.component id={+id} />;
    }
  };

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type="button"
            onClick={backToObjectsList}
            className="btn btn-light"
          >
            <i className="fa fa-arrow-left"></i>
            {intl.formatMessage({ id: "MODULES.GENERAL.BUTTONBACK" })}
          </button>
          {/* {`  `}
            <button className="btn btn-light ml-2" disabled={!isFullAccess}>
              <i className="fa fa-redo"></i>
              {intl.formatMessage({ id: "MODULES.GENERAL.BUTTONRESET" })}
            </button> */}
          {`  `}
          <button
            type="submit"
            className="btn btn-primary ml-2"
            onClick={saveObjectClick}
            disabled={!isFullAccess}
          >
            {intl.formatMessage({ id: "MODULES.GENERAL.BUTTONSAVE" })}

          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <ul className="nav nav-otherTabs nav-otherTabs-line " role="tablist">
          <li className="nav-item" onClick={() => setTab("basic")}>
            <a
              className={`nav-link ${tab === "basic" && "active"}`}
              data-toggle="tab"
              role="tab"
              aria-selected={(tab === "basic").toString()}
            >
              {intl.formatMessage({ id: "ASID.TABS.BASEINFO" })}

            </a>
          </li>
          {/* <li className="nav-item" onClick={() => setTab("contact")}>
              <a
                className={`nav-link ${tab === "contact" && "active"}`}
                data-toggle="tab"
                role="tab"
                aria-selected={(tab === "contact").toString()}
              >
                {intl.formatMessage({ id: "MODULES.BASEINFO.USERS.TAB.UNI" })}

              </a>
            </li> */}

          {/* <li className="nav-item" onClick={() => setTab("card")}>
              <a
                className={`nav-link ${tab === "card" && "active"}`}
                data-toggle="tab"
                role="tab"
                aria-selected={(tab === "card").toString()}
              >
                {intl.formatMessage({ id: "MODULES.BASEINFO.USERS.TAB.CARD" })}

              </a>
            </li> */}

          {/* <li className="nav-item" onClick={() => setTab("login")}>
              <a
                className={`nav-link ${tab === "login" && "active"}`}
                data-toggle="tab"
                role="tab"
                aria-selected={(tab === "login").toString()}
              >
                {intl.formatMessage({ id: "MODULES.BASEINFO.USERS.TAB.LOGIN" })}

              </a>
            </li> */}

          {otherTabs && otherTabs.map(curTab =>
            <>
              {" "}
              <li key={curTab.id} className="nav-item" onClick={() => setTab(curTab.tab)}>
                <a
                  className={`nav-link ${tab === curTab.tab && "active"}`}
                  data-toggle="tab"
                  role="button"
                  aria-selected={(tab === curTab.tab).toString()}
                >
                  {intl.formatMessage({ id: curTab.title })}
                </a>
              </li>
            </>
          )}


        </ul>
        <div className="mt-5">

          {tab === "basic" && (
            <UserEditForm key="basic"
              actionsLoading={actionsLoading}
              object={objectForEdit || initObject}
              btnRef={btnRef}
              saveObject={saveObject}
              formFields={formFields}
              otherFields={otherFields}
              ObjectEditSchema={ObjectEditSchema}
              isFullAccess={isFullAccess}
              prepareFilter={prepareFilter}
              haveImage={false}
            />

          )}
          {/* {tab === "basic" && (
              <UserEditForm key="basic"
                actionsLoading={actionsLoading}
                object={objectForEdit || initObject}
                btnRef={btnRef}
                saveObject={saveObject}
                formFields={formFields.filter(q => q.rowIdx <= 10)}
                otherFields={otherFields}
                ObjectEditSchema={ObjectEditSchema}
                isFullAccess={isFullAccess}
                prepareFilter={prepareFilter}
                haveImage={true}
              />

            )} */}
          {/* {tab === "contact" && (
              <UserEditForm key="contact"
                actionsLoading={actionsLoading}
                object={objectForEdit || initObject}
                btnRef={btnRef}
                saveObject={saveObject}
                formFields={otherFields}
                otherFields={otherFields}
                ObjectEditSchema={ObjectEditSchema}
                isFullAccess={isFullAccess}
                prepareFilter={prepareFilter}
              />
            )} */}

          {/* {tab === "card" && (
              <UserEditForm key="card"
                actionsLoading={actionsLoading}
                object={objectForEdit || initObject}
                btnRef={btnRef}
                saveObject={saveObject}
                formFields={formFields.filter(q => q.rowIdx <= 15 && q.rowIdx >= 11)}
                otherFields={otherFields}
                ObjectEditSchema={ObjectEditSchema}
                isFullAccess={isFullAccess}
                prepareFilter={prepareFilter}
              />

            )} */}
          {/* {tab === "login" && (
              <UserEditForm  key="login"
                actionsLoading={actionsLoading}
                object={objectForEdit || initObject}
                btnRef={btnRef}
                saveObject={saveObject}
                formFields={formFields.filter(q => q.rowIdx <= 15 && q.rowIdx >= 14)}
                otherFields={otherFields}
                ObjectEditSchema={ObjectEditSchema}
                isFullAccess={isFullAccess}
                prepareFilter={prepareFilter}
              />
            )} */}


          {otherTabs && tab !== "basic" && tab !== "card" && otherTabs.map(item =>
            getTab(item)
          )}

        </div>
      </CardBody>
    </Card>
  );
}
